// Brother QL-800 DK ロール定義 (定型 die-cut + 長尺 continuous) と ラベルデータ生成ヘルパー
export const DK_LABELS = [
  { id: '29x90', w: 90, h: 29, roll: 'DK-11201', group: 'die', nameKey: 'mfg.label.size.29x90' },
  { id: '29x62', w: 62, h: 29, roll: 'DK-11209', group: 'die', nameKey: 'mfg.label.size.29x62' },
  { id: '38x90', w: 90, h: 38, roll: 'DK-11208', group: 'die', nameKey: 'mfg.label.size.38x90' },
  { id: '62x100', w: 100, h: 62, roll: 'DK-11202', group: 'die', nameKey: 'mfg.label.size.62x100' },
  { id: '23x23', w: 23, h: 23, roll: 'DK-11221', group: 'die', nameKey: 'mfg.label.size.23x23' },
  { id: '58x58', w: 58, h: 58, roll: 'DK-11207', group: 'die', nameKey: 'mfg.label.size.58x58' },
  { id: '29xAuto', w: 29, h: null, roll: 'DK-22210', group: 'cont', nameKey: 'mfg.label.size.29xAuto' },
  { id: '38xAuto', w: 38, h: null, roll: 'DK-22225', group: 'cont', nameKey: 'mfg.label.size.38xAuto' },
  { id: '62xAuto', w: 62, h: null, roll: 'DK-22205', group: 'cont', nameKey: 'mfg.label.size.62xAuto' },
];

export const DEFAULT_LABEL_SIZE = '29x90';
export const LABEL_SIZE_STORAGE = 'ql800_label_size';

// 種別ごとの既定ロール。Code128 の識別子が長い種別は 23×23 では細バー下限を
// 満たせず印刷できない（技術資産=必要幅44mm・設備台帳=33mm に対し使用可19mm）ので、
// 前回選んだロールが記憶されていても安全な 29×90 から開くようにする。
// ユーザーは変更でき、下限を割るロールは従来どおりダイアログ側が止める。
export const KIND_DEFAULT_SIZE = {
  'eng-asset': '29x90',
  'eng-equipment': '29x90',
};

// ラベルの書体は「測る書体」と「刷る書体」を一致させるための唯一の定義元。
// index.css の `* { font-family: 'IBM Plex Sans JP' … }` は全要素に直接当たるので、
// .ql-label に別の書体を宣言しても子要素（テキスト行）は IBM Plex で描かれる。
// labelLayout の幅計算だけ別書体で測っていると、識別子が「無言で切れる」。
// アプリが実際に読み込んでいる書体スタックに合わせ、子孫まで明示的に指定する。
export const LABEL_FONT_STACK = "'IBM Plex Sans JP','Yu Gothic',YuGothic,'Hiragino Sans',sans-serif";
// 印刷ウィンドウはアプリのCSSを持たないので、同じ書体を自分で読み込む。
export const LABEL_FONT_IMPORT = "@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+JP:wght@400;500;600;700&display=swap');";

// 画面プレビュー & 印刷ウィンドウ 共通スタイル。サイズは各ラベルにインラインで mm 指定するため、
// プレビュー(true mm)と印刷(@page = ラベル寸法)が 1:1 で一致する。@media screen はプレビューのみ。
export const LABEL_STYLE = `
  .ql-label, .ql-label *{ font-family:${LABEL_FONT_STACK}; letter-spacing:normal; }
  .ql-label{ box-sizing:border-box; overflow:hidden; background:#fff; color:#000;
    display:flex; flex-direction:column; }
  .ql-label .ql-bc{ display:flex; align-items:center; justify-content:center; width:100%; overflow:hidden; }
  .ql-label .ql-bc svg{ display:block; height:100%; width:auto; max-width:100%; }
  .ql-label .ql-qr{ display:flex; align-items:center; justify-content:center; width:100%; overflow:hidden; }
  .ql-label .ql-qr svg{ display:block; height:100%; width:auto; max-width:100%; }
  .ql-label .ql-body{ flex:1 1 auto; min-height:0; display:flex; flex-direction:column; justify-content:center; overflow:hidden; }
  .ql-label .ql-ttl{ font-weight:700; font-size:1.15em; line-height:1.2;
    white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  .ql-label .ql-fields{ line-height:1.25; }
  .ql-label .ql-fields > div{ white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  .ql-label .ql-fields b{ font-weight:600; }
  .ql-label .ql-big{ font-weight:800; text-align:center; line-height:1.05;
    white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  .ql-label .ql-sub{ text-align:center; color:#222; line-height:1.15;
    white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  .ql-label .ql-lines{ display:flex; flex-direction:column; min-width:0; }
  /* 省略記号は使わない — 横にあふれる行は「落として明示する」のが仕様（labelLayout.js）。 */
  .ql-label .ql-line{ white-space:nowrap; overflow:hidden; color:#000; }
  @media screen { .ql-preview .ql-label{ flex-shrink:0; box-shadow:0 0 0 1px #d4d4d8, 0 2px 6px rgba(0,0,0,.12); } }
`;

const clean = (arr) => arr.filter(Boolean);

export const buildItemLabel = (it, deptName) => ({
  type: 'item', kind: 'item', barcode: it.barcode || it.sku, title: it.name,
  fields: clean([
    { k: '品目', v: it.sku },
    deptName && { k: '部門', v: deptName },
  ]),
  values: { name: it.name, sku: it.sku, barcode: it.barcode || it.sku, dept: deptName || '' },
});

export const buildLotLabel = (it, lot, locCode, deptName) => ({
  type: 'lot', kind: 'lot', barcode: lot.lot_no, title: it.name,
  fields: clean([
    { k: 'ロット', v: lot.lot_no },
    { k: '数量', v: `${lot.quantity} ${it.uom || ''}`.trim() },
    lot.expiry_date && { k: '有効期限', v: String(lot.expiry_date).slice(0, 10) },
    { k: '棚番', v: locCode || '—' },
  ]),
  values: {
    name: it.name, lot_no: lot.lot_no, quantity: `${lot.quantity} ${it.uom || ''}`.trim(),
    expiry: lot.expiry_date ? String(lot.expiry_date).slice(0, 10) : '', loc: locCode || '',
    barcode: lot.lot_no, dept: deptName || '',
  },
});

// 棚ラベル: ロケーションコード（大きく）＋ 名称 のみ。
// 部門は不変ではない（棚が動かないまま管轄が変わり、その時に棚ラベルを刷り直す人はいない）
// ので載せない — 校正期限と同じ理由。倉庫は不変だが、棚の前に立っている読み手には
// 既知の情報で、通路の向こうから読むコードの高さを奪うだけなので載せない。
// 標準規則: ラベルに刷るのは「ラベル寿命の間に不変」かつ「読み手の立ち位置から自明でない」項目。
export const buildLocationLabel = (loc, deptName) => ({
  type: 'location', kind: 'location', barcode: loc.code,
  big: loc.name && loc.name !== loc.code ? loc.name : null,
  values: { name: loc.name || loc.code, code: loc.code, warehouse: loc.warehouse || '', barcode: loc.code, dept: deptName || '' },
});

export const buildEquipmentLabel = (eq, deptName) => ({
  type: 'equipment', kind: 'equipment', barcode: eq.asset_no, title: eq.name,
  fields: clean([
    { k: '設備番号', v: eq.asset_no },
    { k: '種別', v: eq.kind_label || '—' },
    eq.location_name && { k: '設置場所', v: eq.location_name },
    deptName && { k: '部門', v: deptName },
  ]),
  values: {
    name: eq.name, asset_no: eq.asset_no, kind: eq.kind_label || '',
    location: eq.location_name || '', barcode: eq.asset_no, dept: deptName || '',
  },
});

// IT資産 / 消耗品 label — reuses the `equipment` kind so existing templates
// designed for 設備 also work for IT assets. Falls back to a default line-item
// layout when no template is selected. `deptName` is optional (looked up by
// caller from the department directory when available).
export const buildAssetLabel = (asset, deptName) => ({
  type: 'equipment', kind: 'equipment', barcode: asset.asset_tag || asset.id, title: asset.name,
  fields: clean([
    asset.asset_tag && { k: '資産番号', v: asset.asset_tag },
    asset.category && { k: '種別', v: asset.category },
    asset.location && { k: '設置場所', v: asset.location },
    (deptName || asset.assigned_to_name) && { k: '担当', v: deptName || asset.assigned_to_name },
    asset.purchase_date && { k: '購入日', v: String(asset.purchase_date).slice(0, 10) },
  ]),
  values: {
    name: asset.name, asset_no: asset.asset_tag || asset.id, kind: asset.category || '',
    location: asset.location || '', barcode: asset.asset_tag || asset.id,
    dept: deptName || asset.assigned_to_name || '',
  },
});

export const buildProductTagLabel = (order, line) => ({
  type: 'product_tag', kind: 'product_tag', barcode: order.order_no, title: line.name || line.part_no,
  fields: clean([
    { k: '注文No', v: order.order_no },
    { k: '品番', v: line.part_no || '—' },
    { k: '数量', v: `${line.qty} ${line.uom || ''}`.trim() },
    order.supplier?.name && { k: '仕入先', v: order.supplier.name },
    { k: '納入日', v: order.due_date || order.order_date || '—' },
  ]),
  values: {
    name: line.name || line.part_no, order_no: order.order_no, part_no: line.part_no || '',
    quantity: `${line.qty} ${line.uom || ''}`.trim(), supplier: order.supplier?.name || '',
    due: order.due_date || order.order_date || '', barcode: order.order_no,
  },
});

// ── Designer field catalog + sample data per kind ───────────────────────────
// `barcode` is a pseudo-field = the code encoded in the barcode/QR element.
export const LABEL_KINDS = {
  item: {
    label: '品目', fields: [
      { key: 'name', label: '品名' }, { key: 'sku', label: '品番' },
      { key: 'dept', label: '部門' }, { key: 'barcode', label: 'コード文字' },
    ],
  },
  lot: {
    label: 'ロット', fields: [
      { key: 'name', label: '品名' }, { key: 'lot_no', label: 'ロット番号' },
      { key: 'quantity', label: '数量' }, { key: 'expiry', label: '有効期限' },
      { key: 'loc', label: '棚番' }, { key: 'barcode', label: 'コード文字' },
    ],
  },
  location: {
    label: 'ロケーション', fields: [
      { key: 'name', label: '名称' }, { key: 'code', label: 'コード' },
      { key: 'warehouse', label: '倉庫' }, { key: 'barcode', label: 'コード文字' },
    ],
  },
  equipment: {
    // 表示名のみ「（製造）」で区別する。kind キー 'equipment' は既存テンプレートが
    // 紐づいているため絶対に変更しない。
    label: '設備・工具（製造）', fields: [
      { key: 'name', label: '品名' }, { key: 'asset_no', label: '設備番号' },
      { key: 'kind', label: '種別' }, { key: 'location', label: '設置場所' },
      { key: 'dept', label: '部門' }, { key: 'barcode', label: 'コード文字' },
    ],
  },
  'eng-asset': {
    // 技術資産。設備・工具(equipment)の項目とは記録の形が違うため別カインドにする。
    label: '技術資産', fields: [
      { key: 'name', label: '品名' }, { key: 'sku', label: '品番' },
      { key: 'location_path', label: '現在地' }, { key: 'model_no', label: '型式' },
      { key: 'barcode', label: 'コード文字' },
    ],
  },
  'eng-equipment': {
    // 設備台帳（技術部）。製造の 設備・工具(equipment) とは別台帳なので kind も分ける。
    label: '設備（技術）', fields: [
      { key: 'name', label: '品名' }, { key: 'equip_no', label: '設備番号' },
      { key: 'maker', label: 'メーカー' }, { key: 'model_no', label: '型式' },
      { key: 'location', label: '設置場所' }, { key: 'barcode', label: 'コード文字' },
    ],
  },
  product_tag: {
    label: '製品タグ', fields: [
      { key: 'name', label: '品名' }, { key: 'order_no', label: '注文No' },
      { key: 'part_no', label: '品番' }, { key: 'quantity', label: '数量' },
      { key: 'supplier', label: '仕入先' }, { key: 'due', label: '納入日' },
      { key: 'barcode', label: 'コード文字' },
    ],
  },
};

export const LABEL_SAMPLE = {
  item: { barcode: 'ITM-0005', values: { name: 'サンプル品目 ABC-123', sku: 'ITM-0005', dept: 'センスビー製造部' } },
  lot: { barcode: 'LOT-20260101-001', values: { name: 'サンプル品目', lot_no: 'LOT-20260101-001', quantity: '50 個', expiry: '2026-12-31', loc: 'A-01' } },
  location: { barcode: 'A-01', values: { name: '資材棚A', code: 'A-01', warehouse: '第1倉庫' } },
  equipment: { barcode: 'EQ-001', values: { name: 'リフロー炉', asset_no: 'EQ-001', kind: '設備', location: '製造ライン1', dept: 'センスビー製造部' } },
  'eng-asset': { barcode: 'SZ202600018', values: { name: '特注ヒーターブラケット', sku: 'SZ202600018', location_path: '技術部 / 部品棚A', model_no: 'SUS304 t3.0' } },
  'eng-equipment': { barcode: 'EQ-0007', values: { name: '恒温槽', equip_no: 'EQ-0007', maker: 'エスペック', model_no: 'SU-262', location: '技術部 試験室' } },
  product_tag: { barcode: 'ORD-1001', values: { name: '完成品A', order_no: 'ORD-1001', part_no: 'PRD-0001', quantity: '100 個', supplier: 'サンプル商事', due: '2026-07-15' } },
};

export const sizeById = (id) => DK_LABELS.find((s) => s.id === id) || DK_LABELS[0];


// 技術資産（開発・技術部の資産台帳）— 既存の buildAssetLabel は IT資産専用なので触らない。
// コードは Code128・ペイロード=品番(SKU)。実機スキャン試験でQRのディープリンクが
// ハンディ・スマホカメラの両方で読めなかったため、他9箇所の Code128 利用箇所
// （製造在庫・IT資産など）と同じ形式に戻した。`format` を持たせないのも他9箇所と
// 同じで、印刷ダイアログの既定 'code128' がそのまま効く。
// 引き換えに、スキャンで可変状態（状態・現在地・予約）は見えなくなり識別子だけになる。
// 短縮ルート /q/a/{id} は既に貼られたQRシールのために残す（新規発行はしない）。
export const buildEngAssetLabel = (asset) => ({
  type: 'eng-asset', kind: 'eng-asset',
  barcode: asset.sku || asset.asset_no || '',
  title: asset.name,
  // 品番（無ければ資産番号）が識別子。両方無い記録は印刷させない — 追跡できない
  // タグを実物に貼らせないため。代替の識別子（UUID等）は人間に無意味なので使わない。
  identityMissing: (asset.sku || asset.asset_no)
    ? null
    : { field: '品番', message: '品番が未設定のため印刷できません。資産を編集して品番を発番してください。' },
  fields: clean([
    { k: '品番', v: asset.sku || asset.asset_no },
    asset.location_path && { k: '現在地', v: asset.location_path },
    asset.model_no && { k: '型式', v: asset.model_no },
  ]),
  values: {
    name: asset.name || '',
    sku: asset.sku || asset.asset_no || '',
    location_path: asset.location_path || '',
    model_no: asset.model_no || '',
  },
});


// 設備台帳（技術部）— Code128・ペイロード=設備番号。理由は buildEngAssetLabel と同じ。
// 短縮ルート /q/e/{id} は既に貼られたQRシールのために残す（新規発行はしない）。
// ラベルに載せるのはラベル寿命の間に変わらない項目のみ（識別・設置場所・メーカー・型式）。
export const buildEngEquipmentLabel = (eq) => ({
  type: 'eng-equipment', kind: 'eng-equipment',
  barcode: eq.equip_no || '',
  title: eq.name,
  // Code128 のペイロードが識別子そのものになったので、識別子が無い記録は
  // 空のバーコードになる（jsbarcode も描画できない）。印刷させない。
  identityMissing: eq.equip_no
    ? null
    : { field: '設備番号', message: '設備番号が未設定のため印刷できません。設備を編集して設備番号を登録してください。' },
  fields: clean([
    { k: '設備番号', v: eq.equip_no },
    eq.location && { k: '設置場所', v: eq.location },
    eq.maker && { k: 'メーカー', v: eq.maker },
    eq.model_no && { k: '型式', v: eq.model_no },
  ]),
  values: {
    name: eq.name || '',
    equip_no: eq.equip_no || '',
    maker: eq.maker || '',
    model_no: eq.model_no || '',
    location: eq.location || '',
  },
});


// 部品受注入力 — PIC が発注後に貼るバーコードラベル（バーコード = REQ番号）。
// reuses the `product_tag` kind so its templates apply.
export const buildPartsReqLabel = (req) => ({
  type: 'product_tag', kind: 'product_tag', barcode: req.request_no,
  title: req.order_name || (req.lines && req.lines[0] && req.lines[0].name) || req.request_no,
  fields: [
    { k: '依頼No', v: req.request_no },
    req.techs_order_no ? { k: 'Techs受注', v: req.techs_order_no } : null,
    req.manufacturing_no ? { k: '製番', v: req.manufacturing_no } : null,
    { k: '依頼者', v: req.requested_by || '—' },
    { k: '明細', v: `${(req.lines || []).length}件` },
  ].filter(Boolean),
  values: {
    name: req.order_name || (req.lines && req.lines[0] && req.lines[0].name) || '',
    order_no: req.request_no,
    part_no: (req.lines && req.lines[0] && req.lines[0].part_no) || '',
    barcode: req.request_no,
  },
});
